import React from 'react';
import { Chip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { healthLevel } from '../../utils/health';

/**
 * Colour-coded ecosystem health label, the standard chip size everywhere.
 * Colour never stands alone: the text names the level.
 */
const HealthChip = ({ value }) => {
  const level = healthLevel(value);
  return (
    <Chip
      label={level.label}
      sx={{
        color: 'text.primary',
        bgcolor: alpha(level.color, 0.14),
        '&::before': {
          content: '""',
          width: 8,
          height: 8,
          ml: 1,
          mr: -0.5,
          borderRadius: '50%',
          bgcolor: level.color,
        },
      }}
    />
  );
};

export default HealthChip;
